/*
  Product add-ons (snippets/product-addons.liquid) — replaces the Infinite Options app.

  - Checkbox groups are joined into one line-item property on the main product.
  - Paid choices (inputs with data-variant-id) are added to the cart as their own
    products, just before Dawn's product-form adds the main product, so the cart
    notification and cart count reflect everything. If the main product then fails
    to add, the add-ons are removed again.
*/
(function () {
  document.querySelectorAll('[data-product-addons]').forEach(function (root) {
    var form = document.getElementById(root.dataset.formId);
    if (!form) return;
    var productForm = form.closest('product-form');
    var productTitle = root.dataset.productTitle;

    // Remove the old app's injected fields so they never submit with the form.
    function removeOldApp() {
      document.querySelectorAll('#infiniteoptions-container').forEach(function (el) {
        el.remove();
      });
    }
    removeOldApp();
    new MutationObserver(removeOldApp).observe(document.body, { childList: true, subtree: true });

    function syncMulti() {
      root.querySelectorAll('[data-addon-multi]').forEach(function (hidden) {
        var values = Array.prototype.map.call(
          hidden.closest('fieldset').querySelectorAll('input[type="checkbox"]:checked'),
          function (box) { return box.value; }
        );
        hidden.value = values.join(', ');
        hidden.disabled = values.length === 0;
      });
    }
    root.addEventListener('change', syncMulti);
    syncMulti();

    function selectedAddons(quantity) {
      return Array.prototype.map.call(root.querySelectorAll('input[data-variant-id]:checked'), function (input) {
        return {
          id: Number(input.dataset.variantId),
          quantity: quantity,
          properties: { 'Add-on for': productTitle },
        };
      });
    }

    function removeLines(lines) {
      return lines.reduce(function (chain, line) {
        return chain.then(function () {
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          });
        });
      }, Promise.resolve());
    }

    // Capture phase on document runs before Dawn's submit listener on the form.
    document.addEventListener(
      'submit',
      function (evt) {
        if (evt.target !== form || !productForm) return;
        syncMulti();
        var quantity = Number(new FormData(form).get('quantity')) || 1;
        var items = selectedAddons(quantity);
        if (!items.length) return; // nothing extra — let Dawn handle it as usual

        evt.preventDefault();
        evt.stopImmediatePropagation();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || 'Could not add options to cart');
              return data.items || [];
            });
          })
          .then(function (addedLines) {
            // If the main product fails to add, take the add-ons back out of the cart.
            // Dawn's pubsub: `subscribe` and the `PUB_SUB_EVENTS` const are globals, not window properties.
            var hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
            var unsubscribe = hasPubSub
              ? subscribe(PUB_SUB_EVENTS.cartError, function (event) {
                  if (event.source !== 'product-form') return;
                  unsubscribe();
                  removeLines(addedLines);
                })
              : function () {};
            if (hasPubSub) {
              var unsubscribeOk = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
                if (event.source !== 'product-form') return;
                unsubscribe();
                unsubscribeOk();
              });
            }
            // Hand off to Dawn's normal add-to-cart for the main product.
            productForm.onSubmitHandler(evt);
          })
          .catch(function (err) {
            console.error(err);
            if (productForm.handleErrorMessage) productForm.handleErrorMessage(err.message);
          });
      },
      true
    );
  });
})();
